import React from "react";
import PropTypes from "prop-types";
import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";

import Overlay from "shared/components/FullscreenOverlay";
import useLockBodyScroll from "shared/hooks/useLockBodyScroll";
import ModalRoot from "shared/components/ModalRoot/ModalRoot";

const _modalTransitionProps = {
	transitionName: "modal",
	transitionAppear: true,
	transitionAppearTimeout: 300,
	transitionEnterTimeout: 300,
	transitionLeaveTimeout: 150,
};

const stopClick = (e) => e.stopPropagation();

const Modal = ({
	show,
	className,
	children,
	title,
	noClose,
	onCancel,
	isSaving,
	willCloseOnClick,
	style,
	overlayRef,
	id,
}) => {
	useLockBodyScroll(show);

	if (!show) {
		return null;
	}

	const classes = `OkModalContent reactmodal ${className}`;
	const onClick = willCloseOnClick ? onCancel : null;

	return (
		<ModalRoot>
			<CSSTransitionGroup {..._modalTransitionProps}>
				<div className="OkModal OkModal--scrollingoverlay">
					<Overlay onClick={onClick} scrollRef={overlayRef}>
						<div id={id} className={classes} style={style} onClick={stopClick} role="presentation">
							<div className="OkModalContent-main">
								{!!(title || !noClose) &&
								<div className="reactmodal-header">
									{!!title &&
										<span className="reactmodal-header-title">
											{title}
										</span>
									}
									{!noClose &&
										<button
											className="reactmodal-header-close"
											onClick={onCancel}
											disabled={isSaving}>
											<span className="reader-text">close this modal</span>
											<span className="icon" />
										</button>
									}
								</div>
								}

								<div className="reactmodal-contents">
									{children}
								</div>

							</div>
						</div>
					</Overlay>
				</div>
			</CSSTransitionGroup>
		</ModalRoot>
	);
};

Modal.propTypes = {
	show: PropTypes.bool.isRequired,
	children: PropTypes.node.isRequired,
	title: PropTypes.string,
	noClose: PropTypes.bool,
	onCancel: PropTypes.func.isRequired,
	isSaving: PropTypes.bool,
	className: PropTypes.string,
	willCloseOnClick: PropTypes.bool,
	style: PropTypes.object,
	overlayRef: PropTypes.object,
	id: PropTypes.string,
};

Modal.defaultProps = {
	overlayRef: null,
	className: "",
	id: "",
};

export default Modal;



// WEBPACK FOOTER //
// ./src/shared/components/Modal.jsx